/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

export type BlankEnum = typeof BlankEnum[keyof typeof BlankEnum];


export const BlankEnum = {
  '': '',
} as const;
